import { PaziaBadgeStatus } from "components/atoms";
import { COURSE_STATUS_COLORS, COURSE_STATUS_NAMES, CourseStatus } from "consts/courseType";
import { ThemeColors } from "consts/theme";
import React from "react";

interface CourseBadgeStatusProps {
  status: CourseStatus;
}
export const CourseBadgeStatus = ({ status }: CourseBadgeStatusProps) => {
  if (!status) return null;
  return (
    <PaziaBadgeStatus size="xs" color={COURSE_STATUS_COLORS[status] as ThemeColors}>
      {COURSE_STATUS_NAMES[status]}
    </PaziaBadgeStatus>
  );
};
